<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="厂商" prop="company_id">
        <company-select v-model="form.company_id" clearable :disabled="!!row"/>
      </el-form-item>
      <el-form-item label="型号名称" prop="name">
        <el-input v-model.trim="form.name" clearable placeholder="输入或复制粘贴型号" :disabled="!!row"></el-input>
      </el-form-item>
      <el-form-item label="LAN个数" prop="lan_number">
        <el-input-number v-model="form.lan_number" :precision="0" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="WAN个数" prop="wan_number">
        <el-input-number v-model="form.wan_number" :precision="0" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="WiFi2.4g个数" prop="wifi2g_number">
        <el-input-number v-model="form.wifi2g_number" :precision="0" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="WiFi5g个数" prop="wifi5g_number">
        <el-input-number v-model="form.wifi5g_number" :precision="0" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="WiFi6g个数" prop="wifi6g_number">
        <el-input-number v-model="form.wifi6g_number" :precision="0" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="生成流水" prop="use_sequence">
        <el-radio-group v-model="form.use_sequence">
          <el-radio v-for="item in sequenceStatus" :key="item.id" :label="item.id">{{item.msg}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="校验和" prop="use_checksum">
        <el-radio-group v-model="form.use_checksum">
          <el-radio v-for="item in checksumStatus" :key="item.id" :label="item.id">{{item.msg}}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,changeEmpty} from '@utils/validate'
  import CompanySelect from "@view/components/select/CompanySelect"
  import {sequenceStatus, checksumStatus} from "@utils/formatList"
  export default {
    name: "ModelOperate",
    components: {CompanySelect},
    props: {dialogData: Object},
    data() {
      return {
        sequenceStatus,
        checksumStatus,
        form: {
          name: "",
          company_id: "",
          lan_number: 0,
          wan_number: 0,
          wifi2g_number: 0,
          wifi5g_number: 0,
          wifi6g_number: 0,
          use_sequence: 1,
          use_checksum: 0,
        },
        rules: {
          name: [inputEmpty('型号名称')],
          company_id: [changeEmpty('厂商')],
        },
        row: this.dialogData.row,
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {};
            this.copyObjValue(nv, this.form);
            let res = await this.$Http.addModel(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        Object.entries(this.form).forEach(([key, value]) => value !== row[key] && (nv[key] = value));
        if (Object.keys(nv).length) {
          this.$refs["form"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该型号", async () => {
                nv.device_model_id = row.id;
                let res = await this.$Http.reviseModel(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    }
  }
</script>

<style scoped>

</style>
